<router-outlet></router-outlet>

@if(loading){
    <div class="background-container">
        <app-navbar [isDarkNavbar]="true"></app-navbar>
        <div class="router-container">
            <div class="spinner-container">
                <div class="spinner"></div>
              </div>
        </div>
      </div>
}